// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Nu59N","buttons":"Footer_buttons__MHX6x"};